























































































































import Vue from "vue"
import { ShipmentParcelShop } from "@/model/entity/shipment/shipment-parcel-shop"
import { ParcelShop } from "@/model/entity/parcel-shop/parcel-shop"
import { IParcelShopService, parcelShopService } from "@/model/service/parcel-shop/parcel-shop-service"
import { FieldDescription } from "@/model/entity/field-descriptor"
import Datatable, {DatatableOptions, IDatatable} from "@/components/datatable/Datatable.vue"
import { CreateParcelModel } from "@/model/new-parcel-model/create-parcel-model"
import { classToClass } from "class-transformer"
import {Filter} from "@/model/dto/filter"
import {AxiosPromise} from "axios"
import {Page} from "@/model/dto/page"

export interface IParcelShopGroup extends Vue {
  getParcelShop(): ShipmentParcelShop

  focusAutocomplete(): void

  setParcelShopFromShipment(parcelShop: ShipmentParcelShop): void

  clearAll(): void

  emitValidation(): void
}

interface ParcelShopGroupData {
  parcelShopDialog: boolean
  parcelShop: ShipmentParcelShop | null
  originalParcelShop: ParcelShop | null
  parcelShopService: IParcelShopService
  form: any
  options: DatatableOptions
  fields: FieldDescription[]
  rules: any
}

export default Vue.extend({
  components: { Datatable },
  data(): ParcelShopGroupData {
    return {
      form: {
        description: ""
      },
      parcelShopDialog: false,
      parcelShop: null,
      originalParcelShop: null,
      parcelShopService: parcelShopService,
      options: {},
      fields: ParcelShop.getFieldDescriptionList(),
      rules: {
        description: [
          {
            required: true,
            message: `${this.$t("user_administration.field_is_required")}`
          }
        ]
      }
    }
  },
  props: {
    parcelShopValidated: {
      type: Boolean,
      required: true
    },
    createParcelModel: {
      type: CreateParcelModel,
      required: true
    },
    hasProductVariant: {
      type: Boolean,
      required: true
    },
    readonly: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    myPageFilter(filters: Filter[]) {
        const filter = new Filter("country", this.createParcelModel.country)
        filters.push(filter)
    },
    emitValidation() {
      this.$emit(
        "update:parcelShopValidated",
        !this.createParcelModel.createParcelModelExtensions.parcelShop.value ||
        (exists(this.form.description) &&
          this.form.description !== "" &&
          exists(this.parcelShop) &&
          exists(this.parcelShop!.pudoId) &&
          this.createParcelModel.createParcelModelExtensions.parcelShop.value)
      )
    },
    clearAll() {
      this.form.description = ""
      this.parcelShop = null
    },
    focusAutocomplete() {
      this.$nextTick(() => {
        const autocomplete = this.$refs.autocomplete as any
        const firstInput = autocomplete.$children[0].$el.children[0] as any
        firstInput.focus()
      })
    },
    openDialog() {
      this.parcelShopDialog = true
    },
    getParcelShop(): ShipmentParcelShop {
      return classToClass(this.parcelShop!)
    },
    setParcelShop(parcelShop: ParcelShop) {
      if (!!parcelShop) {
        this.originalParcelShop = parcelShop
        this.parcelShop = new ShipmentParcelShop(
          parcelShop.parcelShopGeneralInfo.pudoId,
          parcelShop.parcelShopGeneralInfo.name,
          parcelShop.parcelShopGeneralInfo.name2,
          parcelShop.parcelShopGeneralInfo.maxparcel,
          parcelShop.parcelShopGeneralInfo.maxweight,
          parcelShop.parcelShopGeneralInfo.carrierDepot,
          parcelShop.parcelShopAddress.country,
          parcelShop.parcelShopAddress.street,
          parcelShop.parcelShopAddress.propertyNumber,
          parcelShop.parcelShopAddress.address2,
          parcelShop.parcelShopAddress.zipCode,
          parcelShop.parcelShopAddress.town
          )
        this.form.description = parcelShop.parcelShopGeneralInfo.name
      }
      this.parcelShopDialog = false
    },
    setParcelShopFromShipment(parcelShop: ShipmentParcelShop) {
      this.parcelShop = parcelShop
      this.form.description = parcelShop.name
    },
    fuzzySearch(input: string, callback: any) {
      if (exists(input) && input.length >= 3) {
        this.parcelShopService.fuzzySearch(input, this.createParcelModel.country,
        this.createParcelModel.createParcelModelExtensions.cashOnDelivery.value
        ).then(response => {
          callback(
            response.data.map(
              parcelShop =>
                new ParcelShop(
                  parcelShop.parcelShopGeneralInfo,
                  parcelShop.parcelShopAddress,
                  parcelShop.parcelShopHours,
                  parcelShop.parcelShopDowntime,
                  parcelShop.parcelShopDowntimeLine,
                  parcelShop.parcelShopMgmtEntity,
                  parcelShop.id
                )
            )
          )
        })
      } else {
        callback([])
      }
    },
    keyupHandler(event: KeyboardEvent) {
      if (event.ctrlKey && event.shiftKey && (event.key === "S" || event.key === "s")) {
        event.stopPropagation()
        this.openDialog()
      }
    },
    showHint() {
      this.$notify.info({
        title: "Tip",
        message: this.$t("new_parcel.hint.parcel_shop.search_tip").toString(),
        duration: 4000
      })
    }
  },
  watch: {
    "form.description": {
      handler() {
        this.emitValidation()
      }
    },
    "createParcelModel.country": {
       handler() {
         if (exists(this.$refs.datatable)) {
           const datatable = this.$refs.datatable as IDatatable
           datatable.refreshData()
           this.parcelShop = null
           this.originalParcelShop = null
           this.form.description = ""
         }
      }
    }
  },
  mounted() {
    this.emitValidation()
  }
})
